<template>
  <CFormGroup class="form-group form-row">
    <template #label v-if="label">
      <label class="col-form-label col-sm-3">{{ label }}</label>
    </template>
    <template #input>
      <div :class="'mt-auto mb-auto ' + (label ? 'col-sm-9' : 'col-sm-12')">
        <GoogleAutocomplete
          :id="$attrs.id + '-autocomplete'"
          v-bind="$attrs"
          :value="value"
          @input="input"
        />
        <small v-if="description" class="form-text text-muted w-100">{{ description }}</small>
      </div>
    </template>
  </CFormGroup>
</template>

<script>
import GoogleAutocomplete from './GoogleAutocomplete.vue'

export default {
  name: 'GoogleAddress',
  components: {
    GoogleAutocomplete
  },
  props: {
    label: String,
    description: String,
    value: Object
  },
  mounted () {
    //console.log('GoogleAddress mounted', this.value)
  },

  methods: {
    input (address) {
      //console.log('GoogleAddress input', address)
      this.$emit('input', address)
    }
  }
}
</script>